import React from 'react';
import { FormMethod } from './FormMethod';
import { Dialog } from 'primereact/dialog';
import '../methods/styleModal.css'


export const ModalMethod = (props) => {
    const {
        modal, modalTitle, toggle, method,
                validaciones,
                name,code,
                handleInputChange, loading,
                saveCreate,saveUpdate
    } = props;

    return (
        
        <Dialog
            header={modalTitle}
            visible={modal}
            className="small-dialog"
            modal
            closable={true}
            onHide={toggle}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}
        >
            {method === "create" ? (
                <FormMethod
                    button="Crear método"
                    {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveCreate }}
                />
            ) : method === "update" ? (
                <FormMethod
                    button="Actualizar método"
                    {...{ toggle, loading, handleInputChange, name, code, validaciones, methodAction: saveUpdate }}
                />
            ) : null}
        </Dialog>



    );
};